import { useState, useCallback, useEffect, useRef } from 'react';

/**
 * Hook for managing table search state and handlers
 * @param {Object} options - Configuration options
 * @param {string} options.tableTitle - Table title for localStorage key
 * @returns {Object} Search state and handlers
 */
const useTableSearch = ({ tableTitle }) => {
  const searchInputRef = useRef(null);
  const [search, setSearch] = useState('');
  const [searchOpened, setSearchOpened] = useState(false);

  // Load saved search from localStorage
  useEffect(() => {
    const savedSearch = localStorage.getItem(`${tableTitle}_search`) || '';
    if (savedSearch) {
      setSearch(savedSearch);
      setSearchOpened(true);
    }
  }, [tableTitle]);

  const handleToggleSearch = useCallback(() => {
    setSearchOpened((prev) => {
      if (!prev) {
        setTimeout(() => {
          searchInputRef.current && searchInputRef.current.focus();
        }, 0);
      }
      return !prev;
    });
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearch('');
    setSearchOpened(false);
    localStorage.setItem(`${tableTitle}_search`, '');
  }, [tableTitle]);

  const handleSearchChange = useCallback(
    (e) => {
      const value = e.target.value;
      setSearch(value);
      localStorage.setItem(`${tableTitle}_search`, value);
    },
    [tableTitle]
  );

  return {
    search,
    searchOpened,
    searchInputRef,
    handleToggleSearch,
    handleClearSearch,
    handleSearchChange,
  };
};

export default useTableSearch;
